module.exports = __webpack_public_path__ + "static/media/Icon-Laptop.ea779304.png";